<template>
    <div class="card position-sticky top-1 mt-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">
        <li class="nav-item">
          <a class="nav-link text-dark d-flex" data-scroll href="#profile">
            <i class="material-symbols-rounded opacity-10 text-lg me-2">manage_accounts</i>
            <span class="text-sm">{{ $t('user.Profile') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#basic-info">
            <i class="material-symbols-rounded opacity-10 text-lg me-2">receipt_long</i>
            <span class="text-sm">{{ $t('user.Basic_info') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#password">
            <i class="material-symbols-rounded opacity-10 text-lg me-2">lock_reset</i>
            <span class="text-sm">{{ $t('user.Change_password') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#sessions">
            <i class="material-symbols-rounded opacity-10 text-lg me-2">settings_applications</i>
            <span class="text-sm">{{ $t('user.Sessions') }}</span>
          </a>
        </li>     
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#media">
            <i class="material-symbols-rounded opacity-10 text-lg me-2">image</i>
            <span class="text-sm">{{ $t('user.Image') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "ProfileSideNav",
  };
  </script>
  